<script lang="ts">
  import { Support } from "@tastyworks/icons-2.0"
  import { _ } from "svelte-i18n"
  import {
    requestSessionCode,
    sessionCode,
    sessionLoading,
  } from "./session-store"

  interface Props {
    mobile?: boolean
    onError?: (error: unknown) => void
  }

  let { mobile = false, onError }: Props = $props()
</script>

{#if mobile}
  <button
    type="button"
    class="text-general-secondary-text font-small-400 flex flex-col items-center gap-2 disabled:opacity-50"
    disabled={$sessionLoading || !!$sessionCode}
    onclick={() => requestSessionCode(onError)}
  >
    <Support class="size-6" />
    <div class="flex flex-col items-center">
      <span>
        {#if $sessionCode}
          {$sessionCode.slice(0, 3)} {$sessionCode.slice(3)}
        {:else}
          {$sessionLoading
            ? $_("cobrowse.buttonLoading")
            : $_("cobrowse.buttonMobile")}
        {/if}
      </span>
      <span
        class="font-small-400"
        class:invisible={!$sessionCode}
        aria-hidden={!$sessionCode}
      >
        {$_("cobrowse.codeInstructions")}
      </span>
    </div>
  </button>
{:else if $sessionCode}
  <div>
    <p>
      {$_("cobrowse.codeLabel")}
      {$sessionCode.slice(0, 3)}
      {$sessionCode.slice(3)}
    </p>
    <p class="text-general-secondary-label">
      {$_("cobrowse.codeInstructions")}
    </p>
  </div>
{:else}
  <button
    type="button"
    class="flex items-center gap-1 disabled:opacity-50"
    disabled={$sessionLoading}
    onclick={() => requestSessionCode(onError)}
  >
    {$sessionLoading
      ? $_("cobrowse.buttonLoading")
      : $_("cobrowse.buttonDefault")}
    {#if !$sessionLoading}
      <Support class="icon-large w-5" />
    {/if}
  </button>
{/if}
